var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Field } from 'formik';
import { useEffect, useState, } from 'react';
import { ChevronDownOutline } from 'react-ionicons';
var setKeyboardSelectionIndex = function (element, keyboardSelectionIndex, keyboardSelectionIndexFromState, setKeyBoardSelectionIndex) {
    var fakeSelectOptions;
    if (element.classList.contains('cgm-select--state-open')) {
        fakeSelectOptions = element.querySelectorAll('.cgm-select__options__option');
    }
    else {
        return;
    }
    if (keyboardSelectionIndexFromState >= 0) {
        fakeSelectOptions[keyboardSelectionIndexFromState].classList.remove('selected');
    }
    if (keyboardSelectionIndex > fakeSelectOptions.length - 1) {
        setKeyBoardSelectionIndex(0);
        fakeSelectOptions[0].classList.add('selected');
    }
    else if (keyboardSelectionIndex < 0) {
        setKeyBoardSelectionIndex(fakeSelectOptions.length - 1);
        fakeSelectOptions[fakeSelectOptions.length - 1].classList.add('selected');
    }
    else {
        setKeyBoardSelectionIndex(keyboardSelectionIndex);
        fakeSelectOptions[keyboardSelectionIndex].classList.add('selected');
    }
};
export var handleKeyDown = function (event, keyboardSelectionIndex, setKeyBoardSelectionIndex, isOpen, setIsOpen, setSelectedValue, setFieldValue) {
    if (isOpen) {
        switch (event.code) {
            case 'Space':
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                close(event.target, setIsOpen);
                event.preventDefault();
                break;
            case 'ArrowUp':
                setKeyboardSelectionIndex(event.target, keyboardSelectionIndex - 1, keyboardSelectionIndex, setKeyBoardSelectionIndex);
                event.preventDefault();
                break;
            case 'ArrowDown':
                setKeyboardSelectionIndex(event.target, keyboardSelectionIndex + 1, keyboardSelectionIndex, setKeyBoardSelectionIndex);
                event.preventDefault();
                break;
            case 'Enter':
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                selectValue(event.target.querySelector('.selected'), setIsOpen, setSelectedValue, setFieldValue);
                event.preventDefault();
                break;
            default:
                break;
        }
    }
    else {
        switch (event.code) {
            case 'Space':
            case 'ArrowUp':
            case 'ArrowDown':
            case 'Enter':
                // eslint-disable-next-line no-case-declarations
                var target = event.target;
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                open(target.querySelector('.cgm-select__selected'), setIsOpen, setKeyBoardSelectionIndex);
                event.preventDefault();
                break;
            default:
                break;
        }
    }
};
var open = function (element, setIsOpen, setKeyBoardSelectionIndex) {
    var _a, _b;
    if (!element) {
        return;
    }
    setIsOpen(true);
    var fakeSelectElement = element.parentElement;
    var selectElement = fakeSelectElement === null || fakeSelectElement === void 0 ? void 0 : fakeSelectElement.nextElementSibling;
    var fakeSelectOptions = Array.from((_a = fakeSelectElement === null || fakeSelectElement === void 0 ? void 0 : fakeSelectElement.querySelectorAll('.cgm-select__options__option')) !== null && _a !== void 0 ? _a : []);
    var dropDown = (_b = fakeSelectElement === null || fakeSelectElement === void 0 ? void 0 : fakeSelectElement.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement;
    fakeSelectElement === null || fakeSelectElement === void 0 ? void 0 : fakeSelectElement.classList.add('cgm-select--state-open');
    if (!dropDown.classList.contains('field--focused')) {
        dropDown.classList.add('field--focused');
    }
    fakeSelectOptions.forEach(function (optionElement) {
        optionElement.classList.remove('selected');
    });
    if (selectElement.selectedIndex >= 0) {
        fakeSelectOptions[selectElement.selectedIndex].classList.add('selected');
    }
    setKeyBoardSelectionIndex(selectElement.selectedIndex);
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    document.addEventListener('mouseup', function (event) { handleOutsideClick(event, setIsOpen); });
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    document.addEventListener('touchstart', function (event) { handleOutsideClick(event, setIsOpen); });
};
var close = function (element, setIsOpen) {
    var _a;
    if (!element) {
        return;
    }
    setIsOpen(false);
    var fakeSelectElement = element.parentElement;
    var selectElement = fakeSelectElement === null || fakeSelectElement === void 0 ? void 0 : fakeSelectElement.nextElementSibling;
    var dropDown = (_a = fakeSelectElement === null || fakeSelectElement === void 0 ? void 0 : fakeSelectElement.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
    fakeSelectElement.classList.remove('cgm-select--state-open');
    dropDown.classList.remove('field--focused');
    selectElement.dispatchEvent(new FocusEvent('blur'));
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    document.removeEventListener('mouseup', handleOutsideClick);
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    document.removeEventListener('touchstart', handleOutsideClick);
};
var handleOutsideClick = function (event, setIsOpen) {
    var _a;
    if (event.target.closest('.cgm-select')) {
        return;
    }
    close((_a = document.querySelector('.cgm-select--state-open')) === null || _a === void 0 ? void 0 : _a.querySelector('.cgm-select__selected'), setIsOpen);
};
var selectValue = function (element, setIsOpen, setSelectedValue, setFieldValue) {
    var _a, _b, _c, _d;
    if (!element) {
        return;
    }
    var fakeSelectElement = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
    var fakeSelectedElement = (_b = element.parentElement) === null || _b === void 0 ? void 0 : _b.previousElementSibling;
    var selectElement = fakeSelectElement === null || fakeSelectElement === void 0 ? void 0 : fakeSelectElement.nextElementSibling;
    var fakeSelectOptions = Array.from((_c = fakeSelectElement === null || fakeSelectElement === void 0 ? void 0 : fakeSelectElement.querySelectorAll('.cgm-select__options__option')) !== null && _c !== void 0 ? _c : []);
    var dropDown = (_d = fakeSelectElement === null || fakeSelectElement === void 0 ? void 0 : fakeSelectElement.parentElement) === null || _d === void 0 ? void 0 : _d.parentElement;
    if (!dropDown.classList.contains('field--filled')) {
        dropDown.classList.add('field--filled');
    }
    if (selectElement.selectedIndex >= 0) {
        fakeSelectOptions[selectElement.selectedIndex].classList.remove('selected');
    }
    fakeSelectedElement.textContent = element.textContent;
    if (setSelectedValue) {
        setSelectedValue(element.dataset.value);
    }
    else if (setFieldValue) {
        setFieldValue(selectElement.name, element.dataset.value);
    }
    else {
        selectElement.value = element.dataset.value;
    }
    // selectElement.dispatchEvent(new Event('input', {bubbles: true}));
    fakeSelectOptions[selectElement.selectedIndex].classList.add('selected');
    close(element.parentElement, setIsOpen);
};
function Error(props) {
    var message = props.message;
    return (_jsx(_Fragment, { children: message
            && _jsx("div", __assign({ className: "field__errors", style: { color: 'red' } }, { children: message })) }));
}
export var onFakeSelectOptionClick = function (event, setIsOpen, setSelectedValue, setFieldValue) {
    selectValue(event.target, setIsOpen, setSelectedValue, setFieldValue);
};
export var onFakeSelectedClick = function (event, isOpen, setIsOpen, setKeyBoardSelectionIndex) {
    var targetElement = event.target;
    if (isOpen) {
        close(targetElement, setIsOpen);
    }
    else {
        open(targetElement, setIsOpen, setKeyBoardSelectionIndex);
    }
};
export function SelectField(props) {
    var label = props.label, fieldName = props.fieldName, error = props.error, options = props.options, initialValue = props.initialValue, setFieldValue = props.setFieldValue, isRequired = props.isRequired;
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(-1), keyboardSelectionIndex = _b[0], setKeyBoardSelectionIndex = _b[1];
    useEffect(function () {
        var _a, _b, _c;
        if (initialValue) {
            var selectElement = document.getElementsByName(fieldName)[0];
            var fakeSelectedElement_1 = (_a = selectElement.previousElementSibling) === null || _a === void 0 ? void 0 : _a.querySelector('.cgm-select__selected');
            var fakeSelectOptions = Array.from((_c = (_b = selectElement.previousElementSibling) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.cgm-select__options__option')) !== null && _c !== void 0 ? _c : []);
            setFieldValue(fieldName, initialValue);
            fakeSelectOptions.forEach(function (option) {
                if (option.dataset.value === initialValue) {
                    fakeSelectedElement_1.textContent = option.textContent;
                }
            });
        }
    }, [initialValue]);
    return (_jsxs("div", __assign({ className: "field field--single-select-dropdown col col-12 col-md-6".concat(error ? ' field--error' : '').concat(initialValue ? ' field--filled' : '') }, { children: [_jsxs("label", { children: [label, isRequired ? _jsx("span", { children: "*" }) : ''] }), _jsxs("div", __assign({ className: "field__input" }, { children: [_jsxs("div", __assign({ className: "cgm-select", tabIndex: 0, onKeyDown: function (event) {
                            handleKeyDown(event, keyboardSelectionIndex, setKeyBoardSelectionIndex, isOpen, setIsOpen, undefined, setFieldValue);
                        } }, { children: [_jsx("div", __assign({ className: "icon icon--size-large lazyloaded" }, { children: _jsx(ChevronDownOutline, { color: "currentColor", height: "100%", width: "100%" }) })), _jsx("div", { className: "cgm-select__selected", onClick: function (event) { return onFakeSelectedClick(event, isOpen, setIsOpen, setKeyBoardSelectionIndex); } }), _jsx("div", __assign({ className: "cgm-select__options" }, { children: options.map(function (option) { return _jsx("div", __assign({ className: "cgm-select__options__option", "data-value": option.code, onClick: function (event) { return onFakeSelectOptionClick(event, setIsOpen, undefined, setFieldValue); } }, { children: option.code }), "cgm-select-option-".concat(option.code)); }) }))] })), _jsx(Field, __assign({ name: fieldName, as: "select", style: { display: 'none' }, required: isRequired !== null && isRequired !== void 0 ? isRequired : false }, { children: options.map(function (option) { return _jsx("option", __assign({ value: option.code }, { children: option.code }), "select-option-".concat(option.code)); }) })), _jsx(Error, { message: error })] }))] })));
}
